import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HvmPage from "@/components/hvm/HvmPage";
import { trackPageview } from "@/utils/analytics";

const Blog = lazy(() => import("@/components/hvm/Blog"));
const Article = lazy(() => import("@/components/hvm/Article"));
const Analytics = lazy(() => import("@/components/analytics/Analytics"));

const PageTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    trackPageview(pathname);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <PageTracker />
      <Suspense fallback={<div className="bg-[#0B0F17] min-h-screen" />}>
        <Routes>
          <Route path="/" element={<HvmPage />} />
          <Route path="/hostile-vehicle-mitigation" element={<HvmPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<Article />} />
          <Route path="/analytics" element={<Analytics />} />
        </Routes>
      </Suspense>
      <Toaster position="top-center" theme="dark" />
    </BrowserRouter>
  );
}

export default App;
